import { get } from '../helpers/api';

export const SERVICE_URI = '/portal';
export const BASE_URI = '/api/v1/restrictions';

export const getRouteGroups = () =>
  get(`${SERVICE_URI}${BASE_URI}/routegroups`, {});
